import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { AgaveWorkspace } from "~/modules/agave/components/agave-workspace";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/agave")({
  component: RouteComponent,
  beforeLoad() {
    ensureSession();
  },
});

function RouteComponent() {
  return (
    <PermissionGuard permission="chat:view">
      <div className="-m-4 h-[calc(100dvh-57px)]">
        <AgaveWorkspace />
      </div>
    </PermissionGuard>
  );
}
